export type ProjectStatus =
  | '待開工'
  | '施工中'
  | '待驗收'
  | '已完工'
  | '停工';

export interface ProjectMeta {
  status: ProjectStatus;
  caseNo: string;
  address: string;
  designer: string;
  foreman: string;
  contractAmount: string;
  startDate: string;
  endDate: string;
  delayDays: string;
  notes: string;
}

/**
 * Gantt 主資料結構：
 *  - rows[group] = { date(YYYY-MM-DD): [item1, item2, ...] }
 *  - 同一格可有多項工項（輸出時用 ", " 串接）
 */
export type GanttData = Record<string, Record<string, string[]>>;

export interface CategoriesResponse {
  groups: string[];
  items: string[];
  holidays: string[];
}

export const DEFAULT_META: ProjectMeta = {
  status: '待開工',
  caseNo: '',
  address: '',
  designer: '',
  foreman: '',
  contractAmount: '',
  startDate: '',
  endDate: '',
  delayDays: '',
  notes: '',
};

export const STATUS_OPTIONS: ProjectStatus[] = [
  '待開工',
  '施工中',
  '待驗收',
  '已完工',
  '停工',
];
